import { Component } from '@angular/core';
import { FlashMessagesService } from '../../services/flash-messages/flash-messages.service';

@Component({
    selector: 'app-flash-messages',
    templateUrl: './flash-messages.component.html',
    styleUrls: ['./flash-messages.component.css']
})
export class FlashMessagesComponent {
    constructor(private flashMessagesService: FlashMessagesService) {
    }

    hasMessages(): boolean {
        return this.flashMessagesService.flashMessages.length > 0;
    }
}
